import { marked } from "marked"
import { configureFSS3 } from "src/context/AuthContextUtility"
import { Storage } from "aws-amplify";
import { Container, Header, SpaceBetween } from "@amzn/awsui-components-react";

export const getResultContent = async (data) => {
  let mdContent = ''
  let jsonData = await loadResultsFromS3(data)
  let resultsView = [];
  if (jsonData?.status_report?.result) {
    mdContent += '------------------------\n'
    mdContent += '# ***Overall summary***  \n ------------------------  \n. \n'
    mdContent += `${jsonData.status_report.result}\n`
    resultsView.push({
      'group': false,
      'header': 'Overall summary',
      'content': jsonData.status_report.result
    })
  }

  if (jsonData?.analysis) {
    mdContent += '------------------------\n'
    mdContent += '# ***Analysis***  \n ------------------------  \n. \n'
    mdContent += `${jsonData.analysis}\n`
    resultsView.push({
      'group': false,
      'header': 'Analysis',
      'content': jsonData.analysis
    })
  }

  if (jsonData?.checks?.length > 0) {
    let checksView = []
    mdContent += '------------------------\n'
    mdContent += '# ***Checks***  \n ------------------------  \n. \n'
    for (let check of jsonData.checks) {
          mdContent += `${check.analysis}\n`
          checksView.push({
              'content': check.analysis,
              'header': check.check_name
          })
    }
    resultsView.push({
      'group': true,
      'header': 'Checks',
      'childContent': checksView
    })
    
  }
  const htmlContent = marked.parse(mdContent);
  return { 'html': htmlContent, 'markdown': mdContent, 'resultObject': resultsView }
}



export const loadResultsFromS3 = async (data) => {
  configureFSS3()
  const fullPath = new URL(data?.response_s3_path)?.pathname?.substring(1);

  // Split into prefix (directory path) and filename
  const lastSlashIndex = fullPath.lastIndexOf('/');
  const prefix = fullPath.substring(0, lastSlashIndex + 1); // Include trailing slash
  const key = fullPath.substring(lastSlashIndex + 1); // Just the filename

  const result = await Storage.get(key, { customPrefix: { public: prefix }, expires: 60, download: true });
  const text = await result.Body.text();
  const jsonData = JSON.parse(text);
  return jsonData
}